import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { StorageService } from '@services';

export const LoginAuthGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  return storage.isAuthenticate();
};

export const NonLoginAuthGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);

  return !storage.isAuthenticate();
};

export const LoginOtpGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  const isLoggedIn = storage.isAuthenticate()

  if (!isLoggedIn) return true
  return false;
};

export const ContactPage: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  const isLoggedIn = storage.isAuthenticate()
  if (!isLoggedIn) return true
  return false;
};
